import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Accordion,
  AccordionPanel,
  Spinner,
  Meter,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  Notes,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
  callApiGetJsonwithEP,
  logAccess,
  APIServerURL,
  debugLog,
} from "./GlobalSettings";
import UserdashboardUpcomingDemos from "./UserdashboardUpcomingDemos";
import CircularProgress from "@material-ui/core/CircularProgress";
import { TrainRounded } from "@material-ui/icons";

class Launchdemospinner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      progressval: this.props.IsFromScheduling ? 15 : 3,
      UpcomingEvents: undefined,
      bLoadUpComingDemoScreen: false,
      bIsComingFromScheduling: this.props.IsFromScheduling,
      bLoadingUpcomingData: this.props.IsFromScheduling,
    };
    this.setprogressionVal = this.setprogressionVal.bind(this);
    this.loadUpcomingEventsData = this.loadUpcomingEventsData.bind(this);
    this._HideUpcomingDemoView = this._HideUpcomingDemoView.bind(this);
    this.loadUpcomingEventsDataForSchdl =
      this.loadUpcomingEventsDataForSchdl.bind(this);
    this._downloadPdf = this._downloadPdf.bind(this);
  }

  componentDidMount() {
    if (!this.props.IsFromScheduling) {
      this.loadUpcomingEventsData();
    } else {
      if (this.props.IsFromScheduling) {
        this.loadUpcomingEventsDataForSchdl();
      }
    }
    this.myInterval = setInterval(() => {
      console.log("Interval started!");
      this.setprogressionVal();
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  _HideUpcomingDemoView() {
    this.setState({ bLoadUpComingDemoScreen: false });
    this.props.hide();
  }

  loadUpcomingEventsData() {
    var endpoint = "/Events/GetUpcomingEventsByUser";
    let token = auth.getToken();
    //this.setState({ showUpcomingEvtLoader: true });

    callApiGetJson(endpoint, token).then((data) => {
      //console.log('Upcoming Events result data from API:');
      //console.log(data);
      this.setState({
        UpcomingEvents: data,
        bLoadingUpcomingData: false,
        //showUpcomingEvtLoader: false,
      });
    });
    //}
  }

  _downloadPdf(dmeoguideId, event) {
    event.stopPropagation();
    var endpoint = "/DocContent/GetDocAccessToken/" + dmeoguideId; // contentRecord.Content_ID;
    let token = auth.getToken();

    callApiGetJson(endpoint, token).then((data) => {
      if (data !== undefined) {
        debugLog(data);
        var elem = window.document.createElement("a");
        elem.href = APIServerURL + "/DocContent/GetDocByToken/" + data.Token;
        elem.target = "_blank";
        elem.download = dmeoguideId + "." + "pdf";
        //contentRecord.Content_Title + "." + contentRecord.Content_Format;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    });

    //this just refreshes the user token if necessary
    auth.verifyToken(true);
    logAccess(
      dmeoguideId,
      //this.props._demoData.Content_ID,
      "Document",
      // this.props._demoData.Content_Type,
      "DemoGuideDownloaded",
      this.props.calledBy,
      token
    );
  }

  loadUpcomingEventsDataForSchdl() {
    var endpoint = "/Events/GetUpcomingEventsByUser";
    let token = auth.getToken();
    //this.setState({ showUpcomingEvtLoader: true });

    callApiGetJson(endpoint, token).then((data) => {
      //console.log('Upcoming Events result data from API:');
      //console.log(data);
      this.setState({
        UpcomingEvents: data,
        bLoadingUpcomingData: false,
        bLoadUpComingDemoScreen: true,
        //showUpcomingEvtLoader: false,
      });
    });
    //}
  }

  setprogressionVal() {
    if (!this.props.IsFromScheduling) {
      // this.setState({ bLoadingUpcomingData: true });
      // this.loadUpcomingEventsDataForSchdl();
      /*       if (this.state.progressval >= 90) {
        this.setState({ bLoadUpComingDemoScreen: true });
      }
      this.setState({ progressval: this.state.progressval + 15 }); */
      // } else {
      if (this.state.progressval >= 45) {
        this.setState({ bLoadUpComingDemoScreen: true });
      }
      this.setState({ progressval: this.state.progressval + 9 });
    }
  }

  render() {
    var PVal = this.state.progressval;
    var spinnercontent = "";
    console.log("CounterValues is ", PVal);
    var bLoadEvtsScr = this.state.bLoadUpComingDemoScreen;
    var Evts = undefined;

    if (this.state.bLoadingUpcomingData) {
      spinnercontent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner size="small" />
            <Text size="small">Loading Your Upcoming Demo Events...</Text>
          </Box>
        </Layer>
      );
    }

    if (this.state.UpcomingEvents) {
      Evts = this.state.UpcomingEvents;
    }

    return (
      <Layer animate modal>
        {bLoadEvtsScr && Evts && (
          <UserdashboardUpcomingDemos
            Demos={Evts}
            hide={this._HideUpcomingDemoView}
            //LaunchData={DemoLaunchData}
            // LaunchCallBack={this.loadVRNetLaunchInfo}
            // reloadOnchange={this.loadUpcomingEventsData}
          />
        )}
        {spinnercontent}
        {!this.props.IsFromScheduling && (
          <Box align="center" justify="center">
            <Box align="center" justify="center" border={{ style: "solid" }}>
              <Box
                align="center"
                justify="center"
                background={{ color: "brand" }}
                fill="horizontal"
              >
                <Box
                  align="center"
                  justify="between"
                  direction="row"
                  gap="medium"
                  fill="horizontal"
                >
                  <Heading size="small" level="4" margin="small">
                    Preparing your demo...
                  </Heading>
                  <Button
                    icon={<Close />}
                    secondary
                    onClick={this.props.hide}
                  />
                </Box>
              </Box>
              <Box
                align="center"
                justify="center"
                fill="horizontal"
                gap="medium"
                pad="large"
              >
                {this.props.isDemoGuide && (
                  <Box
                    pad="small"
                    // round="full"
                    overflow="hidden"
                    background="brand"
                    animation={{ type: "pulse", duration: 1000 }}
                    elevation="large"
                  >
                    <Button
                      // a11yTitle="2 Available Updates"
                      label="Demo-Guide"
                      icon={<Download color="white" />}
                      onClick={(event) =>
                        this._downloadPdf(this.props.demoGuideID, event)
                      }
                      badge
                      tip="Download Demo-Guide"
                      hoverIndicator
                    />
                  </Box>
                )}
                <Text textAlign="center">
                  Please wait, your demonstration environment is being prepared.
                </Text>
                <Text textAlign="center">
                  You will be redirected to "My Demo Event(s)" where demo can be
                  launched on scheduled time
                </Text>
                <Box
                  align="stretch"
                  justify="center"
                  direction="row"
                  pad={{ bottom: "small" }}
                  gap="xxsmall"
                >
                  {/*                 <Meter
                  type="circle"
                  background="light-2"
                  values={[{ PVal, color: PVal > 120 ? "brand" : "accent-1" }]}
                /> */}
                  <CircularProgress
                    // size='65'
                    //  thickness='5'
                    variant="determinate"
                    color="green"
                    value={PVal}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Layer>
    );
  }
}

export default Launchdemospinner;
